export const WEB_CONFIG = {
  getVehicles: 'vehicle/list-vehicles',
  getFilters: 'vehicle/filter-data',
  getCarDetail: 'vehicle/vehicle-details',
  pickUpLocationAutocomplete: 'vehicle/pickup-location-suggestions',
  validateCar: 'vehicle/rebook-vehicle-search',
  getInTouch: 'onboarding/customer/contact-us',
  driveInvitation: 'onboarding/customer/send-test-drive-invitation',
  subscribeNewsletters: 'onboarding/customer/subscribe-newsletter',
  getExtrasOptions: 'vehicle/list-extras',

  faqs: [
    {
      question: 'How can I book a car?',
      answer:
        'Customers can browse available vehicles, select rental duration, add extras, and confirm the booking.',
    },
    {
      question: 'What documents are required for booking?',
      answer:
        'A valid QID and Driving License must be uploaded and verified before a vehicle can be delivered.',
    },
    {
      question: 'Can I cancel or modify my booking?',
      answer:
        'Yes, cancellations are allowed while the booking is in Booked status. Modifications are subject to availability.',
    },
    {
      question: 'What payment methods are supported?',
      answer:
        'Customers can pay using credit/debit cards or other available payment methods listed at checkout.',
    },
    {
      question: 'How do I track my booking status?',
      answer:
        'All bookings can be tracked under the “My Bookings” section, with statuses like Booked, Picked, Pending Handover, Cancel Request, Returned, etc.',
    },
    {
      question: 'What happens if my KYC is not verified?',
      answer: 'Vehicles will not be delivered until your documents are fully verified by Admin.',
    },
  ],
  slides: [
    {
      id: 1,
      title: 'Ready to hit the road? <br> Book your car today!',
      description:
        'Our friendly customer service team is here to help. Contact us anytime for support and inquiries.',
      image: '/images/premium-cars-header-bg.svg',
    },
    {
      id: 2,
      title: 'Explore new destinations! <br> Rent a car now!',
      description: 'Enjoy seamless booking with our 24/7 support team.',
      image: '/images/premium-cars-header-bg.svg',
    },
    {
      id: 3,
      title: 'Drive with confidence! <br> Book your ride today!',
      description: 'Get the best deals with our exclusive offers.',
      image: '/images/premium-cars-header-bg.svg',
    },
  ],
};
